<template>
  <div
    class="card card-alert mb-2"
    :style="{
      'border-left': '0.4rem solid ' + getColor(color),
      'background-color': getBgColor(bgColor),
    }"
  >
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column">
          <div class="card-title card-title-sm text-xs text-uppercase">
            {{ title }}
          </div>
          <div class="card-text text-xs mt-1 me-2">
            {{ body }}
          </div>
        </div>

        <icon-warning v-if="showIcon" class="mx-2 my-auto" />
      </div>
    </div>
  </div>
</template>

<script>
import styles from "./Alert.vue?vue&type=style&index=0&lang=scss&module=1";
import IconWarning from "@/shared/Controls/Icons/IconWarning.vue";

export default {
  name: "Alert",
  components: {
    IconWarning,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    body: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: styles.white,
    },
    bgColor: {
      type: String,
      default: "info",
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getBgColor(bgColor) {
      let code = bgColor.toLowerCase();

      if (code == "alert") {
        return styles.alert;
      } else return styles.info;
    },
    getColor(color) {
      if (color == "warning") {
        return styles.warning;
      } else if (color == "danger") {
        return styles.danger;
      } else if (color == "suggest") {
        return styles.suggestion;
      } else return color;
    },
  },
};
</script>
<style lang="scss" scoped>
:export {
  danger: $color-danger;
  warning: $color-warning;
  success: $color-success;
  suggestion: $g-steel_800;
  alert: $g-gray-soft;
  info: $g-gray-mute;
}
</style>
